import { Controller } from "@hotwired/stimulus"

// The demo's « 1 Panier — 2 Livraison — 3 Paiement » in the top bar: the step follows the section
// at the middle of the screen. A cart without delivery shows « Panier — Paiement ».
// No optional chaining (Webpacker 5).
export default class extends Controller {
  static targets = ["nav", "delivery", "payment"]
  static values = { labels: Array }

  connect() {
    this.step = -1
    this.onScroll = () => {
      cancelAnimationFrame(this.frame)
      this.frame = requestAnimationFrame(() => this.update())
    }
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    cancelAnimationFrame(this.frame)
  }

  update() {
    const labels = this.hasDeliveryTarget ? this.labelsValue : [this.labelsValue[0], this.labelsValue[2]]
    const mid = window.innerHeight / 2
    const above = (el) => !el.classList.contains("locked") && el.getBoundingClientRect().top < mid
    let step = 0
    if (this.hasDeliveryTarget && above(this.deliveryTarget)) step = 1
    if (this.hasPaymentTarget && above(this.paymentTarget)) step = labels.length - 1
    if (step === this.step) return
    this.step = step
    this.navTarget.innerHTML = labels.map((label, i) => {
      const state = i < step ? "done" : (i === step ? "on" : "")
      return `<span class="s ${state}"><span class="n">${i + 1}</span><span class="lb">${label}</span></span>`
    }).join('<span class="bar"></span>')
  }
}
